import { LastEditedDateDesc } from './instances'

export const CASPacketAttachmentOrderDefault = LastEditedDateDesc
